import React from "react";
import { Alert, Collapse } from "@mui/material";

/**
 * Custom alert component with collapse animation
 * @param {Object} props - Component props
 * @param {boolean} props.open - Whether the alert is visible
 * @param {string} props.message - Alert message
 * @param {string} props.severity - Alert severity (success, error, warning, info)
 * @param {Function} props.onClose - Close handler function
 * @param {Object} props.sx - Additional styles
 * @returns {JSX.Element} Custom alert component
 */
const CustomAlert = ({
  open,
  message,
  severity = "info",
  onClose,
  sx = {},
}) => {
  return (
    <Collapse in={open}>
      <Alert severity={severity} onClose={onClose} sx={{ mb: 3, ...sx }}>
        {message}
      </Alert>
    </Collapse>
  );
};

export default CustomAlert;
